import React from 'react'

const Skillsbar = ({heading,percentage,width}) => {
  return (    
    <div className='flex flex-col w-[480px]   lg:w-4/5'>
    {/* heading */}
    <div className='flex text-white items-center justify-between '>
     <p className='uppercase text-xl  ' >{heading}</p>
     <p className='upercase text-xl'>{percentage}%</p>
    </div>
    {/* percent */}
    <div className='h-2 w-full bg-black rounded-md'>
      <div  className={`bg-red  h-full ${width?`w-${width}`:`w-4/5`}  rounded-s-md`} ></div>  
    </div>
    </div>
  )
}

export default Skillsbar